// extracted by mini-css-extract-plugin
export default {"fullHeight":"VerticalAlign_fullHeight__2uYk1"};